import styled from 'styled-components';

const StyledActionButton = styled.button`
	border-width: 0;
	border-radius: 8px;
	padding: 10px 20px;
	font-family: 'GT Walsheim Pro';
	font-size: 14px;
	font-weight: 400;
	color: #ffffff;
	background-color: #1678c2;
	user-select: none;
	cursor: pointer;
	transition: background-color 0.25s ease;

	&:hover {
		background-color: #2c96e7;
	}

	&:active {
		background-color: #12609b;
	}
`;

export { StyledActionButton };
